import { useEffect, useState } from 'react';
import {
    setCalendarColorDetailsQuery,
    useBookableResourcesQuery,
    useCalendarColorDetailsQuery,
} from '~/lib/Queries';
import useBusinessPostApi from '~/lib/useBusinessPostApi';
import { ratio } from '@opendevtools/wcag-color';
import { isWhiteText } from '~/lib/Colors.js';

const DEFAULT_COLOR = '#3788d8';
const COLORS = [
    '#0056D6',
    '#7A219E',
    '#669D34',
    '#E22400',
    '#DA5100',
    '#D38301',
    '#371A94',
    '#99244F',
    '#D19D01',
    '#008CB4',
];

export default function () {
    const { data: bookableResourceData } = useBookableResourcesQuery();
    const { data: colorData } = useCalendarColorDetailsQuery();
    const { save, isSaving } = useBusinessPostApi(`/calendar/color-details`);
    const resourceColors = colorData?.resourceColors || {};
    const typeColors = colorData?.typeColors || {};
    const [colorBasedOn, setColorBasedOn] = useState(
        colorData?.colorBasedOn || 'resource',
    );

    function getEventType(event) {
        return event.type || event.event_type_id || event.extendedProps?.type;
    }

    useEffect(() => {
        if (colorData?.colorBasedOn) {
            setColorBasedOn(colorData?.colorBasedOn);
        }
    }, [colorData?.colorBasedOn]);

    useEffect(() => {
        if (!bookableResourceData || colorData) {
            return;
        }
        // Set default colors...
        let newColors = {};
        let i = 0;
        for (let resource of bookableResourceData) {
            newColors[resource.id] = COLORS[i % COLORS.length];
            i += 1;
        }

        setCalendarColorDetailsQuery({ resourceColors: newColors });
    }, [bookableResourceData]);

    function getEventColor(event) {
        if (colorBasedOn === 'eventType') {
            const id =
                event.event_type_id ||
                event.event_type?.id ||
                event.extendedProps?.event_type_id;

            return typeColors[id] || DEFAULT_COLOR;
        } else {
            const firstBookableResourceId = event.all_bookable_resource_ids
                ? event.all_bookable_resource_ids[0]
                : false;
            const id =
                firstBookableResourceId ||
                event.bookable_resource_id ||
                event.bookable_resource?.id ||
                event.extendedProps?.bookable_resource_id;

            if (!resourceColors[id]) {
                //console.log('Unable to find color for', id, event, resourceColors);
            }
            return resourceColors[id] || DEFAULT_COLOR;
        }
    }

    function update(newColorData) {
        setCalendarColorDetailsQuery({ ...colorData, ...newColorData });
        save({
            ...colorData,
            ...newColorData,
        });
    }

    function getTextColor(event) {
        if (!getEventType(event)) {
            return null;
        }

        const bgColor = getEventColor(event);
        const whiteText = isWhiteText(bgColor);
        return whiteText ? '#FFFFFFCC' : '#00000099';
    }

    return {
        setResourceColors: newValue => {
            update({ resourceColors: newValue });
        },
        setTypeColors: newValue => {
            update({ typeColors: newValue });
        },
        resourceColors: resourceColors,
        typeColors: typeColors,
        getEventColor,
        getTextColor,
        colorBasedOn,
        setColorBasedOn: newValue => {
            setColorBasedOn(newValue);
            update({ colorBasedOn: newValue });
        },
    };
}
